"use client";

import React from "react";
import { observer } from "mobx-react-lite";
import StrongSymbolRow from "./StrongSymbolRow";

function normalizeTopGroups(top) {
  if (Array.isArray(top)) return top;
  if (!top || typeof top !== "object") return [];

  return Object.entries(top).map(([sector, symbols]) => ({
    sector,
    symbols: Array.isArray(symbols) ? symbols : [],
  }));
}

export function getTopSectorSymbolCount(top) {
  return normalizeTopGroups(top).reduce(
    (sum, group) => sum + (group.symbols?.length || 0),
    0,
  );
}

export default observer(function TopSectorPanel({ data }) {
  const displayGroups = normalizeTopGroups(data?.top);

  if (!displayGroups.length) {
    return (
      <div
        style={{
          fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace",
          fontSize: 12,
          color: "#9ca3af",
          padding: "8px 2px",
        }}
      >
        (no top symbols over 5%)
      </div>
    );
  }

  return (
    <div
      className="font-mono text-sm whitespace-pre leading-5 near-white bg-near-black"
      style={{
        marginBottom: 8,
        borderLeft: "3px solid rgba(34,197,94,.9)",
        padding: 8,
        paddingLeft: 12,
        borderTopLeftRadius: 8,
        borderBottomLeftRadius: 8,
        backgroundColor: "rgba(20,83,45,.3)",
        boxShadow: "0 2px 6px rgba(0,0,0,.25)",
      }}
    >
      {displayGroups.map(({ sector, symbols }, groupIndex) => (
        <div key={sector}>
          {groupIndex > 0 && <div style={{ height: 8 }} />}
          <div
            style={{
              fontSize: 11,
              fontWeight: 600,
              color: "rgba(255,255,255,0.6)",
              textTransform: "uppercase",
              letterSpacing: "0.5px",
              marginBottom: 4,
              paddingLeft: 4,
              borderLeft: "2px solid rgba(255,255,255,0.2)",
            }}
          >
            {sector}
          </div>
          {symbols.map((item) => (
            <StrongSymbolRow
              key={`${sector}-${item.symbol}`}
              sym={item.symbol}
              val={{
                sector: item.sector || sector,
                pattern: item.pattern || "",
                percentChange: item.percentChange,
              }}
              isPos
              colCh={10}
              source="top"
            />
          ))}
        </div>
      ))}
    </div>
  );
});
